import { setToken, getToken, curlHttp, setStore, getStore, localRead } from '@/library/utils'
import api from '../../library/api.service'


export default {
    state: {
        currentProject: {},
        projectItem: [],
        projectTeam: [],
    },
    mutations: {
        setCurrentProject(state, value) {
            state.currentProject = value
        },
        setProjectItem(state, value) {
            state.projectItem = value
        },
        setProjectTeam(state, value) {
            state.projectTeam = value
        }
    },
    actions: {
        handleProject({ commit }, {}) {
            let userinfo = JSON.parse(localRead('userinfo'))
            let params = {
                status: 'CO'
            }
            return new Promise((resolve, reject) => {
                let urls = api.api.project.list
                curlHttp(urls.url, params, urls.method).then(res => {
                    if (res.code === 200) {
                        commit('setProjectItem', res.detail)
                    }
                    resolve(res)
                }).catch(err => {
                    reject(err)
                })
            })
        },
        // 获取项目团队列表
        handleProjectTeam({ commit }, { project }) {
            let params = {
                project: project,
            }
            return new Promise((resolve, reject) => {
                let urls = api.api.team.list
                curlHttp(urls.url, params, urls.method).then(res => {
                    if (res.code === 200) {
                        commit('setProjectTeam', res.detail)
                    }
                    resolve(res)
                }).catch(err => {
                    reject(err)
                })
            })
        },
    }
}
